import React from "react";
import { Sidebar } from "./Sidebar";
import { Footer } from "./Footer";
import { DiseaseDetectionCards } from "./DiseaseDetectionCards";

export const PlantDiseaseDetection = () => {
  return (
    <div>
      <Sidebar />
      <DiseaseDetectionCards />
      <Footer />
      <script src="https://code.jquery.com/jquery-3.5.1.slim.min.js"></script>
      <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js"></script>
      <script type="text/javascript" src="javascript/index.js"></script>
    </div>
  );
};
